import { useComponentRegistry } from '@bem-react/di';
import b from 'b_';
import React from 'react';

import { PaginatorPagesProps } from '../../types';
import { cnPaginator, groupPagesAroundActivePage } from '../../utils';

/**
 * Компонент разбивает страницы на группы вокруг активного пункта
 * Чтобы корректно скрывать посредством CSS пункты, равно удаленные от активного
 * в горизонтальном (мобильном) виде
 */

const PaginatorPagesHorizontal = ({ pages, orientation }: PaginatorPagesProps) => {
    const { PaginatorButton } = useComponentRegistry(cnPaginator());

    const pagesGroups = groupPagesAroundActivePage(pages);

    /**
     * элементы слева от активного реверсим, чтобы не влезали (и скрывались) те элементы,
     * которые находятся дальше от активного, являющегося визуальным центром пагинатора
     */
    const leftPagesReversed = pagesGroups.left.reverse();

    return (
        <>
            <div className="beforeActive">
                {leftPagesReversed.map((page) => (
                    <PaginatorButton
                        clickable={Boolean(page.onClick) && !page.disabled}
                        key={page.text}
                        mix={b('paginator', 'page-button', { orientation })}
                        number={page.number}
                        onClick={!page.disabled ? page.onClick : undefined}
                        selected={page.selected}
                        view={page.view}
                    >
                        {page.text}
                    </PaginatorButton>
                ))}
            </div>
            <div className="active">
                {pagesGroups.active.map((page) => (
                    <PaginatorButton
                        clickable={Boolean(page.onClick) && !page.disabled}
                        key={page.text}
                        mix={b('paginator', 'page-button', { orientation })}
                        number={page.number}
                        onClick={!page.disabled ? page.onClick : undefined}
                        selected={page.selected}
                        view={page.view}
                    >
                        {page.text}
                    </PaginatorButton>
                ))}
            </div>
            <div className="afterActive">
                {pagesGroups.right.map((page) => (
                    <PaginatorButton
                        clickable={Boolean(page.onClick) && !page.disabled}
                        key={page.text}
                        mix={b('paginator', 'page-button', { orientation })}
                        number={page.number}
                        onClick={!page.disabled ? page.onClick : undefined}
                        selected={page.selected}
                        view={page.view}
                    >
                        {page.text}
                    </PaginatorButton>
                ))}
            </div>
        </>
    );
};

export default PaginatorPagesHorizontal;
